import React from 'react';
import DocumentsRepeater from '../../components/Documents/DocumentsRepeater';
import { toast } from 'react-toastify';
import { getUrlExtension } from '../../helpers/CommonHelpers';
import { useState } from 'react';
import download from 'downloadjs';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';

const KeyPickupDocuments = ({ importantDocuments, user }) => {
  const [isOpen, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const onClick = (data) => {
    if (data.includes('.mp4')) {
      toast.success(
        `Your document download has started, It may take some time.`,
        { autoClose: 12000, position: 'top-center' }
      );
    }
    download(data);
  };

  const onImageClicked = (x, image) => {
    setOpen(true);
    setSelectedImage(image);
  };

  return (
    <>
      <h3>Important Documents</h3>
      <DocumentsRepeater
        user={user}
        documents={importantDocuments}
        onDownload={onClick}
        onClick={(x, image) =>
          getUrlExtension(image) === 'heic' ? null : onImageClicked(x, image)
        }
        from={'keypickup'}
      />
      {isOpen && isOpen === true ? (
        <ReusableLightbox
          isOpen={isOpen}
          onClose={() => setOpen(false)}
          image={selectedImage}
        />
      ) : null}
    </>
  );
};
export default KeyPickupDocuments;
